export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14331.20f0bb47.jpg";